"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaylinkErrorToJSON = exports.PaylinkErrorFromJSONTyped = exports.PaylinkErrorFromJSON = void 0;
function PaylinkErrorFromJSON(json) {
    return PaylinkErrorFromJSONTyped(json, false);
}
exports.PaylinkErrorFromJSON = PaylinkErrorFromJSON;
function PaylinkErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorText': json['errorText'],
    };
}
exports.PaylinkErrorFromJSONTyped = PaylinkErrorFromJSONTyped;
function PaylinkErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorText': value.errorText,
    };
}
exports.PaylinkErrorToJSON = PaylinkErrorToJSON;
//# sourceMappingURL=PaylinkError.js.map